import React from "react";
//#region components
import TopTodoCard from "components/todos/_partials/topTodoCard";
import { AgentSaleMissingInformationTodoFooter, useAgentSaleSnoozeAction } from "components/agentSale";
import { BulletList, FooterWithDivider, TitledContainerInner, EntityCardContent } from "components/common";
//#endregion
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const AgentSaleMissingInformationTodo: React.FC<TodoCardProps> = (props) => {
  const agentSaleMissingInformation = props.item.agentSaleMissingInformation;
  const objectNumber = agentSaleMissingInformation?.objectNumber;
  const objectAddress = agentSaleMissingInformation?.objectAddress;
  const externalSystemName = agentSaleMissingInformation?.externalSystemName;
  const missingItems = agentSaleMissingInformation?.missingInformationTexts;
  const receivedDate = DateHelper.formatDate(props.item.date);

  const { snoozeAction, onSnoozeClicked } = useAgentSaleSnoozeAction(props.item.id, props.onActionSuccess);

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingOne={objectNumber}
          descriptionHeadingTwo={objectAddress}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Received
          )}: ${receivedDate}`}
          quickActions={[snoozeAction]}
        />
      }
      todoMainSection={
        <TitledContainerInner
          header={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.AgentSale.MissingInformation
          )} ${externalSystemName}`}
          subHeader={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.AgentSale.MissingInformationTodoDescription,
            undefined,
            { objectNumber: objectNumber ?? "", externalSystemName: externalSystemName ?? "" }
          )}
        >
          <FooterWithDivider
            footerTitle={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.AgentSale.MissingInformationBulletTitle
            )}
          />
          <BulletList items={missingItems ?? []} icon={IconDefinitionConstants.WArrowSmallRight} />
        </TitledContainerInner>
      }
      footer={<AgentSaleMissingInformationTodoFooter onSnoozeClicked={onSnoozeClicked} />}
    ></EntityCardContent>
  );
};

export default AgentSaleMissingInformationTodo;
